import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import {store} from './store'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGeolocation from 'vue-browser-geolocation'


// components
import alart from './components/shared/Alert.vue'
import appLoading from './components/shared/loading.vue'
import phoneUi from './components/shared/signUserInWithPhone'

// third party components
Vue.use(VueAxios, axios)
Vue.use(VueGeolocation)

// shared components
Vue.component('app-alert', alart)
Vue.component('app-loading', appLoading)
Vue.component('phone-ui', phoneUi)



const auth = getAuth()

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
  created () {
    onAuthStateChanged(auth, (user) => {
      // console.log(user)
      if (user) {
          this.$store.dispatch('fetchUserData', user)
        }
      })
    }

}).$mount('#app')
